import { autoinject, bindable, observable } from "aurelia-framework";
import { ReportFinancialPrecision } from "../models/report-template";

@autoinject
export class FinancialPrecisionSelector {
	@bindable selectionChanged: (params: { precision: ReportFinancialPrecision }) => void;
	@bindable initialValue: ReportFinancialPrecision;
	@bindable useFullWidth: boolean = false;
	@observable selectedFinancialPrecision: ReportFinancialPrecision;
	
	decimalOption = ReportFinancialPrecision.Decimal;
	integerOption = ReportFinancialPrecision.Integer;
	thousandsOption = ReportFinancialPrecision.Thousands;
	
  	constructor() {}
		
	attached() {
		this.selectedFinancialPrecision = this.initialValue ?? ReportFinancialPrecision.Decimal;
	}
	
	selectedFinancialPrecisionChanged() {
		if (!this.selectionChanged) {
			return;
		}
		
		this.selectionChanged({ precision: this.selectedFinancialPrecision });
	}
}
